import { useEffect, useState } from "react";
import { db } from "@/os/data";
import { useClientSeenQuotes } from "@/os/permissions/useClientSeenQuotes";

/**
 * Returns the number of quotes (status = sent) that the current client
 * viewer has not yet opened. RLS already scopes listQuotes() to their own
 * quotes, so a plain list call is enough.
 */
export function useClientUnseenQuotes(enabled: boolean) {
  const seen = useClientSeenQuotes((s) => s.seen);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    let live = true;
    (async () => {
      try {
        const rows = (await db().listQuotes()) as any[];
        if (!live) return;
        const seenSet = new Set(seen);
        setCount(rows.filter((r) => r.status === "sent" && !seenSet.has(r.id)).length);
      } catch { /* ignore */ }
    })();
    return () => { live = false; };
  }, [enabled, seen]);

  return count;
}